import React from "react";
import Preloader from "../../Global/Preloader";
import Headertwo from "../Mainhometwo/Headertwo";
import Bannertwo from "../Mainhometwo/Bannertwo";
import Aboutone from "../Mainhometwo/Aboutone";
import Featurestwo from "../Mainhometwo/Featurestwo";
import Servicestwo from "../Mainhometwo/Servicestwo";
// import Ctatwo from "../Mainhometwo/Ctatwo";
// import Processtwo from "../Mainhometwo/Processtwo";
// import Casestudiestwo from "../Mainhometwo/Casestudiestwo";
// import Featuresthree from "../Mainhometwo/Featuresthree";
// import Whychoosetwo from "../Mainhometwo/Whychoosetwo";
// import Testimonialtwo from "../Mainhometwo/Testimonialtwo";
// import Blogtwo from "../Mainhometwo/Blogtwo";
// import Inquiryone from "../Mainhometwo/Inquiryone";
import Footertwo from "../Mainhometwo/Footertwo";
import BackToTop from "../../Global/BackToTop";

const Main = () => {
  return (
    <>
      <Preloader />
      <Headertwo />
      <Bannertwo />
      <Aboutone />
      <Featurestwo />
      <Servicestwo />
      {/* <Ctatwo /> */}
      {/* <Processtwo /> */}
      {/* <Casestudiestwo /> */}
      {/* <Featuresthree /> */}
      {/* <Whychoosetwo /> */}
      {/* <Testimonialtwo /> */}
      {/* <Blogtwo /> */}
      {/* <Inquiryone /> */}
      <Footertwo />
      <BackToTop />
    </>
  );
};
export default Main;
